var React = require('react');

function ThermometerFull (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M272 278.5V112a112 112 0 0 0-224 0v166.5C28.3 303.2 16 334 16 368a144 144 0 0 0 288 0c0-34-12.3-64.9-32-89.5zM160 448a79.87 79.87 0 0 1-48-143.8V112a48 48 0 0 1 96 0v192.2A79.87 79.87 0 0 1 160 448z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M208 368a48 48 0 1 1-64-45.1V112a16 16 0 0 1 32 0v210.9a47.87 47.87 0 0 1 32 45.1z","className":"fa-primary","key":2})]);
}

ThermometerFull.defaultProps = {"viewBox":"0 0 320 512","className":"icon"};

module.exports = ThermometerFull;

ThermometerFull.default = ThermometerFull;
